<section>
  <div class="mascot-card">
    <img [src]="images?.TALK_TO_EXPERT" class="img-dy" alt="mascot" />
    <span class="mascot-text expert-sub fs-16">
      {{ 'WE_WILL_CLEAR_ALL_YOUR_DOUBTS' | fallbackTranslate }}
    </span>
  </div>
  <div class="form-header">
    {{ 'LOVE_TO_KNOW_ABOUT_YOUR_BUSINESS' | fallbackTranslate }}
  </div>
  <form nz-form [formGroup]="expertForm">
    <ng-container *ngFor="let field of formFields">
      <div>
        <nz-form-label nzRequired class="form-label fw-400 clr-333 expert-sub">
          {{ field?.label }}
        </nz-form-label>
      </div>
      <input
        class="wd-100 form-input"
        nz-input
        [type]="field.inputType"
        placeholder="{{ field?.placeholder }}"
        nzSize="large"
        formControlName="{{ field?.name }}"
      />
      <div
        class="error-message"
        *ngIf="
          expertForm.get(field?.name).touched &&
          expertForm.get(field?.name).invalid
        "
        
      >
        <div
          *ngIf="
            field.name === 'email' && expertForm.get(field?.name).errors?.required
          "
        >
          {{ 'EMAIL_REQUIRED' | fallbackTranslate }}
        </div>
        <div
          *ngIf="
            field.name === 'email' && expertForm.get(field?.name).errors?.email
          "
        >
          {{ 'EXPERT_FORM.INVALID_EMAIL' | fallbackTranslate }}
        </div>
        <div
          *ngIf="
            field.name !== 'email' &&
            expertForm.get(field?.name).errors?.required
          "
        >
          {{ field?.label }} {{ 'IS_REQUIRED' | fallbackTranslate }}.
        </div>
      </div>
    </ng-container>
    <div class="footer-btn m-t-8">
      <button
        nz-button
        nzType="default"
        class="wd-100 fw-400 btn-m flex-1 button-bg secondary"
        nzSize="large"
        (click)="dismissModal(0)"
      >
        {{ 'BACK' | fallbackTranslate }}
      </button>
      <button
        nz-button
        nzType="primary"
        class="wd-100 btn-m flex-2 fw-600"
        nzSize="large"
        (click)="submitToExpert()"
        type="submit"
        [nzLoading]="isSubmitting"
      >
        {{ 'SUBMIT' | fallbackTranslate }}
      </button>
    </div>
  </form>
</section>
